// ==============================
// AddEditSession.jsx (FULL)
// ==============================

import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const AddEditSession = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [sessionData, setSessionData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    session_name: '',
    session_start_yr: '',
    session_end_yr: '',
  });

  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    if (location.state) {
      setSessionData((prev) => ({
        ...prev,
        ...location.state,
      }));
    }
  }, [location.state]);

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setSessionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const SaveSession = async () => {
    // Vendor validation
    if (isSuperAdmin && (!sessionData.vendor_id || sessionData.vendor_id <= 0)) {
      toast.error('Please select Vendor');
      return;
    }

    // Branch validation
    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!sessionData.branch_id || sessionData.branch_id <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    if (!sessionData.session_name?.trim()) {
      toast.error('Please enter Session Name');
      return;
    }

    if (!sessionData.session_start_yr) {
      toast.error('Please enter Start Year');
      return;
    }

    if (!sessionData.session_end_yr) {
      toast.error('Please enter End Year');
      return;
    }

    const startYr = Number(sessionData.session_start_yr);
    const endYr = Number(sessionData.session_end_yr);

    if (Number.isNaN(startYr) || startYr <= 0) {
      toast.error('Start Year is invalid');
      return;
    }
    if (Number.isNaN(endYr) || endYr <= 0) {
      toast.error('End Year is invalid');
      return;
    }
    if (startYr > endYr) {
      toast.error('Start Year cannot be greater than End Year');
      return;
    }

    try {
      let res;

      const payload = {
        ...sessionData,
        session_name: sessionData.session_name?.trim(),
        session_start_yr: startYr,
        session_end_yr: endYr,
      };

      // ✅ API same pattern like Weekend
      if (sessionData.id && Number(sessionData.id) > 0) {
        res = await apiService.put(
          `api/SessionMaster/UpdateSession?id=${sessionData.id}`,
          payload
        );
      } else {
        res = await apiService.post('api/SessionMaster/AddSession', payload);
      }

      if (res?.status === true) {
        toast.success(res.message);
        navigate('/list-session');
      } else {
        toast.error(res?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      {/* ✅ SAME STYLE AS WEEKEND / HOLIDAY */}
      <VendorBranchSelector
        user={user}
        selectionData={sessionData}
        setSelectionData={setSessionData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Session Form</span>
          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Session Name</Label>
              <Input
                type='text'
                name='session_name'
                value={sessionData.session_name || ''}
                onChange={onChangeHandle}
                placeholder='e.g. 2025-2026'
              />
            </FormGroup>

            <FormGroup className='col-sm-3'>
              <Label>Start Year</Label>
              <Input
                type='number'
                name='session_start_yr'
                value={sessionData.session_start_yr ?? ''}
                onChange={onChangeHandle}
                placeholder='2025'
                min='1900'
              />
            </FormGroup>

            <FormGroup className='col-sm-3'>
              <Label>End Year</Label>
              <Input
                type='number'
                name='session_end_yr'
                value={sessionData.session_end_yr ?? ''}
                onChange={onChangeHandle}
                placeholder='2026'
                min='1900'
              />
            </FormGroup>
          </Row>

          <Button color='primary' className='float-end mt-3' onClick={SaveSession}>
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditSession;
